export enum VIEW_MODE {
  createTeam = 'create_team',
  editTeam = 'edit_team',
  deleteTeam = 'delete_team',
  viewTeams = 'view_teams',
}
